import { wixSdkAdapter } from './wixSdkAdapter';
import { getDeviceTypeByViewportWidth } from './documentWidth';
import { DeviceType } from '../types/DeviceType';

export const getDeviceType = (): DeviceType =>
  (wixSdkAdapter.getDeviceType() as DeviceType) ||
  getDeviceTypeByViewportWidth();
